import { Injectable } from '@angular/core';
import { RegConfig } from '../../../shared/models';

@Injectable({ providedIn: 'root' })
export class ClearedTabService {
  private static readonly COMPOUND_DIM_IDS = ['KW_TO_INCREASE', 'KW_TO_DECREASE', 'PRICE_TO_INCREASE', 'PRICE_TO_DECREASE'];

  // ::TODO: This is a temporary fix for the Polish market. The proper solution is to have the backend return a different graph_config for the Polish market (consolidated to hourly) vs. other markets (split dimensions). Once that is done, this service can be removed and the logic can be handled in the OpenGraphService.
  isConsolidatedToHourly(regViewConfig: RegConfig | null): boolean {
    const consolidateDimensions = regViewConfig?.graph_config?.consolidate_dimensions_into_hourly;
    return !!consolidateDimensions;
  }

  isSeriesHiddenForMarket(seriesName: string, isConsolidatedToHourly: boolean): boolean {
    // Polish market (consolidated to hourly) does not show Cleared Demand
    return isConsolidatedToHourly && !!seriesName?.toLowerCase().includes('demand');
  }
}
